import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ScreenReaderAnnouncer from './ScreenReaderAnnouncer';
import Home from './Home';
import NavMenu from './NavMenu';
import Footer from './Footer';
import FooterMDG from './FooterMDG';
import GForm from './GForm';
import ManagedDentalGuard from './ManagedDentalGuard';
const App = () => {
  return (
    <><ScreenReaderAnnouncer />
      <div>

        <div className="row custom-margin" style={{ height: '4.5rem' }} role="banner">
          <NavMenu />
        </div>

        <div className="row custom-bg-gray custom-margin1" role="main">
          <div className="container custom-bg-gray" style={{ paddingTop: 20 }}>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/GrievanceForm" element={<GForm />} />
              <Route exact path="/managed-dental-guard" element={<ManagedDentalGuard />} />
            </Routes>
          </div>
        </div>
          <div className="row custom-margin1 footer-custom-styling" style={{ background: '#0a2c41' }}  >
            <Routes>
              <Route exact path="/" element={<Footer />} />
              <Route exact path="/GrievanceForm" element={<Footer />} />
              <Route exact path="/managed-dental-guard" element={<FooterMDG />} />
            </Routes>
        </div>
      </div>
    </>
  );
};

export default App;
